const NotFoundPage= ()=>{
    return <h1 className="text-center mt-12">Page Not Found</h1>
}

export default NotFoundPage